import React, { useState, useEffect, Suspense, lazy } from 'react';
import SearchAllSites from '../SearchAllSites/SearchAllSites';
import HelpButton from '../HelpButton/HelpButton';
import AdminButton from '../AdminButton/AdminButton';
import ProfileInfo from '../../../shared/components/ProfileInfo/ProfileInfo';
import { IconButton } from '@fluentui/react';
import { Link } from '@fluentui/react';
import './TopBar.scss';
import { EventBus, EventNames } from '../../../shared/eventbus/eventbus';

const WidgetApp = lazy(() => import('../../../widget/routes/WidgetApp/WidgetApp'));

const WidgetAppButton = (props: { className: string }) => (
    <Suspense fallback={null}>
        <WidgetApp ensureAuthenticated={false} linkOnlyMode={false} className={props.className} loginHint="" />
    </Suspense>
);

const TopBarHeader = (props: { className?: string }) => (
    <header className={props.className}>
        <Link href="https://mybcecatholicedu.sharepoint.com">Brisbane Catholic Education</Link>
    </header>
);

const TopBar: React.FC = () => {
    const [areOptionsExpanded, setAreOptionsExpanded] = useState(false);
    const [isSearchExpanded, setIsSearchExpanded] = useState(false);

    const showMoreOptions = () => setAreOptionsExpanded(true);

    const hideOptions = () => {
        setAreOptionsExpanded(false);
        setIsSearchExpanded(false);
    };

    const toggleSearch = () => setIsSearchExpanded((prev) => !prev);

    const showGlobalSearch = () => {
        setAreOptionsExpanded(true);
        setIsSearchExpanded(true);
    };

    useEffect(() => {
        EventBus.subscribe(EventNames.MakeSureGlobalSearchIsVisible, showGlobalSearch);
        EventBus.subscribe(EventNames.MakeSureHelpIsVisible, showMoreOptions);

        return () => {
            EventBus.unsubscribe(EventNames.MakeSureGlobalSearchIsVisible, showGlobalSearch);
            EventBus.unsubscribe(EventNames.MakeSureHelpIsVisible, showMoreOptions);
        };
    }, []);

    return (
        <div className="TopBar">
            <div className="Full ms-slideLeftIn20">
                <TopBarHeader />
                <SearchAllSites className="LargeScreen" />
                <HelpButton className="LargeScreen" />
                <AdminButton className="LargeScreen" />
                <WidgetAppButton className="LargeScreen" />
                <ProfileInfo />
            </div>
            <div className="Medium ms-slideLeftIn20">
                <TopBarHeader />
                <IconButton iconProps={{ iconName: 'Search' }} onClick={toggleSearch} className="SearchButton" />
                <HelpButton className="MediumScreen" />
                <AdminButton className="MediumScreen" />
                <WidgetAppButton className="MediumScreen" />
                <ProfileInfo />
            </div>
            <div className="Small ms-slideLeftIn20">
                {areOptionsExpanded ? (
                    <>
                        <IconButton iconProps={{ iconName: 'Clear' }} onClick={hideOptions} className="CloseButton ms-slideLeftIn20" />
                        <IconButton iconProps={{ iconName: 'Search' }} onClick={toggleSearch} className="SearchButton ms-slideLeftIn20" />
                        <HelpButton className="ms-slideLeftIn20 SmallScreen" />
                        <AdminButton className="ms-slideLeftIn20 SmallScreen" />
                        <WidgetAppButton className="ms-slideLeftIn20 SmallScreen" />
                    </>
                ) : (
                    <>
                        <TopBarHeader className="ms-slideLeftIn20" />
                        <IconButton iconProps={{ iconName: 'More' }} onClick={showMoreOptions} className="MoreButton ms-slideLeftIn20" />
                    </>
                )}
                <ProfileInfo />
            </div>
            {isSearchExpanded && (
                <div className="SearchContainer ms-slideDownIn20">
                    <SearchAllSites className="SmallScreen" />
                </div>
            )}
        </div>
    );
};

export default TopBar;
